import { IWidgetCard } from '@entities/widget-card/model/types';
import { TPaymentMethodType, TWidgetPlan } from '@entities/widget-shop/model/types';
import { useYandexMetrika } from '@shared/lib';

interface ITrackEvent {
    widget: IWidgetCard;
    isRecurrent?: boolean;
    paymentType?: TPaymentMethodType;
    widgetPlan?: TWidgetPlan;
}

const getActiveCompanyTariffFromDom = () => {
    if (typeof document === 'undefined') {
        return '';
    }

    return (
        document.querySelector<HTMLElement>('[data-active-tariff-title]')?.dataset
            ?.activeTariffTitle ?? ''
    );
};

export const useMetricTracker = () => {
    const { trackEvent } = useYandexMetrika();
    const resolvedActiveCompanyTariff = getActiveCompanyTariffFromDom();

    const trackers = {
        viewFullDescription: ({ widget }: ITrackEvent) => {
            trackEvent('widgets', 'viewFullDescription', {
                widgetTitle: widget.title,
                activeCompanyTariff: resolvedActiveCompanyTariff,
            });
        },
        connect: ({ widget }: ITrackEvent) => {
            trackEvent('widgets', 'connect', {
                widgetTitle: widget?.title,
                activeCompanyTariff: resolvedActiveCompanyTariff,
                isFree: widget?.isFree,
            });
        },
        purchase: ({ widget, isRecurrent, paymentType, widgetPlan }: ITrackEvent) => {
            trackEvent('widgets', 'purchase', {
                widgetTitle: widget?.title,
                activeCompanyTariff: resolvedActiveCompanyTariff,
                isRecurrent,
                paymentType,
                widgetPlan,
            });
        },
        prolong: ({ widget }: ITrackEvent) => {
            trackEvent('widgets', 'prolong', {
                widgetTitle: widget.title,
                activeCompanyTariff: resolvedActiveCompanyTariff,
            });
        },
    };

    return {
        trackers,
    };
};
